import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { createEarlyAdopterHandler } from '@/utils/earlyAdopterInterceptor';

const ClosingCTASection = () => {
  const { openModal } = useEarlyAdopter();

  return (
    <div className="py-24 lg:py-32 relative overflow-hidden">
      {/* Rich gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/8 via-primary/5 to-background"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>

      <div className="relative container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground">
            Ready to Take Control of Your Independence?
          </h2>
          <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed">
            Everything you need to stay safe, healthy, and connected at home, in one place.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              size="lg"
              variant="gradient"
              className="text-lg px-10 shadow-overlay min-h-[56px]"
              onClick={createEarlyAdopterHandler(openModal, 'Features CTA - Get Started')}
            >
              Get Early Access
              <ArrowRightIcon className="ml-2 w-5 h-5" />
            </Button>
            <Button asChild variant="outline" size="lg" className="text-lg px-8 min-h-[48px]">
              <Link to="/pricing">See Pricing</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClosingCTASection;
